import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=48a716be&scoped=true"
import script from "./SearchView.vue?vue&type=script&lang=js"
export * from "./SearchView.vue?vue&type=script&lang=js"
import style0 from "./SearchView.vue?vue&type=style&index=0&id=48a716be&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a716be",
  null
  
)

export default component.exports